import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { addRemoveError, getControl, getFormArray } from '@shared/helpers/form.helper';
import { toNum } from '@shared/helpers/math.helper';
import { isNilOrEmpty, isNilOrEmptyOrZero } from '@shared/helpers/utils.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { isEqual } from 'lodash-es';
import { getContribBiennaleControl } from './helpers/contrib-biennale-form.helpers';

export const contribBiennalePagamentiRules: FormGroupRules = {
    my_id_mezzoPagamentoContributoRevisione: (form: FormGroup) => {
        const my_RTRigaCalcoloMoraSanzioneFormArray = getFormArray(form, 'my_RTCalcoloMoraSanzione.my_RTRigaCalcoloMoraSanzione');
        my_RTRigaCalcoloMoraSanzioneFormArray?.controls?.forEach((group: FormGroup) => {
            const my_id_mezzoPagamentoContributoRevisioneControl = getControl(group, 'my_id_mezzoPagamentoContributoRevisione');
            const my_id_mezzoPagamentoContributoRevisione = toNum(my_id_mezzoPagamentoContributoRevisioneControl?.value);
            const showError = isNilOrEmptyOrZero(my_id_mezzoPagamentoContributoRevisione) && my_RichiedeDettagliContributoVersatoHelper(form);
            const errors = my_id_mezzoPagamentoContributoRevisioneControl.errors ? my_id_mezzoPagamentoContributoRevisioneControl.errors : {};

            addRemoveError(showError, errors, 'my_id_mezzoPagamentoContributoRevisione', {
                status: REQUIRED_STATUS,
            });

            my_id_mezzoPagamentoContributoRevisioneControl.setErrors(isEqual(errors, {}) ? null : errors);
        });
    },

    my_IbanOrdinante: (form: FormGroup) => {
        const my_RTRigaCalcoloMoraSanzioneFormArray = getFormArray(form, 'my_RTCalcoloMoraSanzione.my_RTRigaCalcoloMoraSanzione');
        my_RTRigaCalcoloMoraSanzioneFormArray?.controls?.forEach((group: FormGroup) => {
            const ibanOrdinateControl = getControl(group, 'my_IbanOrdinante');
            const my_IbanOrdinante: string = ibanOrdinateControl.value;
            const my_id_mezzoPagamentoContributoRevisione = toNum(getControl(group, 'my_id_mezzoPagamentoContributoRevisione')?.value);
            const my_id_mezzoPagamentoContributoRevisioneCondition = my_id_mezzoPagamentoContributoRevisione === 3 || my_id_mezzoPagamentoContributoRevisione === 2;
            const requiredCondition =
                isNilOrEmpty(ibanOrdinateControl?.value) && my_RichiedeDettagliContributoVersatoHelper(form) && my_id_mezzoPagamentoContributoRevisioneCondition;
            const invalidIbanCondition = my_IbanOrdinante?.length !== 27 && my_RichiedeDettagliContributoVersatoHelper(form) && my_id_mezzoPagamentoContributoRevisioneCondition;
            const errors = ibanOrdinateControl.errors ? ibanOrdinateControl.errors : {};

            addRemoveError(invalidIbanCondition, errors, 'ibanOrdinate', {
                status: 'IBAN di lunghezza errata',
            });

            addRemoveError(requiredCondition, errors, 'ibanOrdinate', {
                status: REQUIRED_STATUS,
            });

            ibanOrdinateControl.setErrors(isEqual(errors, {}) ? null : errors);
        });
    },

    my_NumeroAssegno: (form: FormGroup) => {
        const my_RTRigaCalcoloMoraSanzioneFormArray = getFormArray(form, 'my_RTCalcoloMoraSanzione.my_RTRigaCalcoloMoraSanzione');
        my_RTRigaCalcoloMoraSanzioneFormArray?.controls?.forEach((group: FormGroup) => {
            const my_NumeroAssegnoControl = getControl(group, 'my_NumeroAssegno');
            const my_id_mezzoPagamentoContributoRevisione = toNum(getControl(group, 'my_id_mezzoPagamentoContributoRevisione')?.value);
            const showError = isNilOrEmpty(my_NumeroAssegnoControl?.value) && my_RichiedeDettagliContributoVersatoHelper(form) && my_id_mezzoPagamentoContributoRevisione === 3;
            const errors = my_NumeroAssegnoControl.errors ? my_NumeroAssegnoControl.errors : {};

            addRemoveError(showError, errors, 'my_NumeroAssegno', {
                status: REQUIRED_STATUS,
            });

            my_NumeroAssegnoControl.setErrors(isEqual(errors, {}) ? null : errors);
        });
    },

    my_NumeroContoCorrente: (form: FormGroup) => {
        const my_RTRigaCalcoloMoraSanzioneFormArray = getFormArray(form, 'my_RTCalcoloMoraSanzione.my_RTRigaCalcoloMoraSanzione');
        my_RTRigaCalcoloMoraSanzioneFormArray?.controls?.forEach((group: FormGroup) => {
            const my_NumeroContoCorrenteControl = getControl(group, 'my_NumeroContoCorrente');
            const my_id_mezzoPagamentoContributoRevisione = toNum(getControl(group, 'my_id_mezzoPagamentoContributoRevisione')?.value);
            const showError =
                isNilOrEmpty(my_NumeroContoCorrenteControl?.value) && my_RichiedeDettagliContributoVersatoHelper(form) && my_id_mezzoPagamentoContributoRevisione === 4;
            const errors = my_NumeroContoCorrenteControl.errors ? my_NumeroContoCorrenteControl.errors : {};

            addRemoveError(showError, errors, 'my_NumeroContoCorrente', {
                status: REQUIRED_STATUS,
            });

            my_NumeroContoCorrenteControl.setErrors(isEqual(errors, {}) ? null : errors);
        });
    },

    my_AltroMezzoPagamento: (form: FormGroup) => {
        const my_RTRigaCalcoloMoraSanzioneFormArray = getFormArray(form, 'my_RTCalcoloMoraSanzione.my_RTRigaCalcoloMoraSanzione');
        my_RTRigaCalcoloMoraSanzioneFormArray?.controls?.forEach((group: FormGroup) => {
            const my_AltroMezzoPagamentoControl = getControl(group, 'my_AltroMezzoPagamento');
            const my_id_mezzoPagamentoContributoRevisione = toNum(getControl(group, 'my_id_mezzoPagamentoContributoRevisione')?.value);
            const showError =
                isNilOrEmpty(my_AltroMezzoPagamentoControl?.value) && my_RichiedeDettagliContributoVersatoHelper(form) && my_id_mezzoPagamentoContributoRevisione === 6;
            const errors = my_AltroMezzoPagamentoControl.errors ? my_AltroMezzoPagamentoControl.errors : {};

            addRemoveError(showError, errors, 'my_AltroMezzoPagamento', {
                status: REQUIRED_STATUS,
            });

            my_AltroMezzoPagamentoControl.setErrors(isEqual(errors, {}) ? null : errors);
        });
    },
};

const my_RichiedeDettagliContributoVersatoHelper = (form: FormGroup) => {
    const my_RichiedeDettagliContributoVersato: string = getContribBiennaleControl(form, 'my_RichiedeDettagliContributoVersato')?.value;
    return my_RichiedeDettagliContributoVersato === 'S';
};
